import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedAddons: [],
  addOnInfo: {},
  loading: false,
  errorMsg: {},
  isModalOpen: false,
  continueAddon: false,
  selectedFrequentAddons: {},
  cartItemIndex: -1,
};

export const AddOn = createSlice({
  name: "addOn",
  initialState,
  reducers: {
    addOnModalVisibility: (state, action) => {
      return {
        ...state,
        isModalOpen: action?.payload,
        continueAddon: action?.payload === false ? false : state.continueAddon,
      };
    },
    requestToFetchAddOnInfoAction: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    successToFetchAddOnInfoAction: (state, action) => {
      return {
        ...state,
        loading: false,
        addOnInfo: action.payload,
      };
    },
    failToFetchAddOnInfoAction: (state, action) => {
      return {
        ...state,
        loading: false,
        errorMsg: action.payload,
      };
    },
    handleFrequentlyBoughtAddons: (state, action) => {
      return {
        ...state,
        selectedFrequentAddons: action.payload,
      };
    },
    addAddonToCartAction: (state, action) => {
      return {
        ...state,
        loading: true,
        cartItemIndex: Number(Object.fromEntries(new URLSearchParams(action.payload))?.cartItemIndex),
      };
    },
    successAddonToCartAction: (state) => {
      return {
        ...state,
        loading: false,
        continueAddon: true,
      };
    },
    failAddonToCartAction: (state, action) => {
      return {
        ...state,
        loading: false,
        errorMsg: action.payload,
      };
    },
  },
});

export default AddOn.reducer;
export const {
  addOnModalVisibility,
  requestToFetchAddOnInfoAction,
  successToFetchAddOnInfoAction,
  failToFetchAddOnInfoAction,
  addAddonToCartAction,
  successAddonToCartAction,
  failAddonToCartAction,
  handleFrequentlyBoughtAddons,
} = AddOn.actions;
